import * as React from 'react';
import styled from 'styled-components';

import {copyDoPasso} from './RegisterForm.copy';
import {RegisterDeviceShowcase} from './RegisterDeviceShowcase';

const Painel = styled.aside`
  background: linear-gradient(160deg, #006bf3 0%, #0b1b33 100%);
  color: #fff;
  padding: 48px 44px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 1023px) {
    padding: 28px 20px;
    gap: 14px;
  }
`;

const Logo = styled.img`
  width: 170px;
  align-self: flex-start;
`;

const Chapeu = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 12px;
  opacity: 0.75;
`;

const Titulo = styled.h2`
  font-size: 34px;
  line-height: 1.15;
  margin: 0;
  font-weight: 700;

  @media (max-width: 1023px) {
    font-size: 24px;
  }
`;

const Subtitulo = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  opacity: 0.85;
`;

const Lista = styled.ul`
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Item = styled.li`
  display: flex;
  gap: 12px;
  align-items: flex-start;

  strong {
    display: block;
    font-size: 15px;
    margin-bottom: 2px;
  }

  span {
    font-size: 14px;
    line-height: 1.45;
    opacity: 0.8;
  }
`;

const Marcador = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;

  svg {
    width: 12px;
    height: 12px;
  }
`;

const Rodape = styled.p`
  margin-top: auto;
  font-size: 13px;
  opacity: 0.65;
`;

const Check = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

interface Props {
  step: number;
  logoUrl?: string;
  avatarUrl?: string | null;
  nome?: string | null;
}

export const RegisterBrandPanel: React.FC<Props> = ({step, logoUrl, avatarUrl, nome}) => {
  const copy = copyDoPasso(step);
  const ultimoPasso = step === 3;

  return (
    <Painel>
      {logoUrl && <Logo src={logoUrl} alt="Millbody" />}

      <div>
        <Chapeu>{copy.chapeu}</Chapeu>
        <Titulo>{copy.titulo}</Titulo>
      </div>

      <Subtitulo>{copy.subtitulo}</Subtitulo>

      {/* No ultimo passo os aparelhos substituem a lista: e onde a pessoa ve o
          proprio rosto no app que esta prestes a criar. */}
      {ultimoPasso ? (
        <RegisterDeviceShowcase avatarUrl={avatarUrl} nome={nome} />
      ) : (
        <Lista>
          {copy.beneficios.map((beneficio) => (
            <Item key={beneficio.titulo}>
              <Marcador>
                <Check />
              </Marcador>
              <div>
                <strong>{beneficio.titulo}</strong>
                <span>{beneficio.descricao}</span>
              </div>
            </Item>
          ))}
        </Lista>
      )}

      <Rodape>Millbody — a plataforma de quem vive de treinar gente.</Rodape>
    </Painel>
  );
};
